import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Zap, ArrowLeft, Mail } from "../utils/icons";
import Button from "../components/ui/Button";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address");
      return;
    }
    setError("");
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1200));
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 font-display font-bold text-xl mb-10">
          <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center">
            <Zap size={16} className="text-white" />
          </div>
          <span className="gradient-text">NexaFlow</span>
        </div>

        {!sent ? (
          <>
            <h1 className="font-display text-3xl font-bold text-gray-900 dark:text-white mb-2">
              Forgot password?
            </h1>
            <p className="text-gray-500 dark:text-gray-400 mb-8">
              No worries. Enter your email and we'll send a reset link.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                  Email address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`input-field ${error ? "!border-red-400" : ""}`}
                  placeholder="you@company.com"
                />
                {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              </div>
              <Button
                type="submit"
                className="w-full"
                size="lg"
                loading={loading}
              >
                Send Reset Link
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-900/30 rounded-2xl flex items-center justify-center mx-auto mb-5">
              <Mail size={28} className="text-emerald-500" />
            </div>
            <h1 className="font-display text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Check your inbox
            </h1>
            <p className="text-gray-500 dark:text-gray-400 mb-6">
              We've sent a reset link to{" "}
              <strong className="text-gray-700 dark:text-gray-300">
                {email}
              </strong>
              . It expires in 30 minutes.
            </p>
            <Button
              onClick={() => setSent(false)}
              variant="ghost"
              className="w-full"
              size="lg"
            >
              Resend email
            </Button>
          </div>
        )}

        <Link
          to="/login"
          className="flex items-center justify-center gap-2 mt-6 text-sm text-gray-500 hover:text-primary-600 transition-colors"
        >
          <ArrowLeft size={16} /> Back to login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
